import React from 'react';
import bgVideo from '../../images/home/bgApp.mp4';

const VideoBackground = ({ children }) => {
  return (
    <div className="video-background-container">
      <video autoPlay loop muted playsInline className="background-video">
        <source src={bgVideo} type="video/mp4" />
        ...
      </video>
    </div>
  );
};

export default VideoBackground;
